import type {NationalAgent, NationalAgentType} from 'services/agent/types';

export const createEmptyNationalAgent = (
  agentType: NationalAgentType,
): NationalAgent =>
  ({
    agentType,
  }) as NationalAgent;
